export default __webpack_public_path__ + "static/media/LightBlue0007.f6ce7025.png";